import React from "react";

export const VisualAttribute = ({ title, children, className }) => {
  return (
    <div
      className={`flex flex-col gap-2 text-wce-neutral-9 break-words ${className}`}
    >
      <span className="text-sm">{title}</span>
      <span className="font-medium">{children}</span>
    </div>
  );
};
